export function gmap_form(company) {
  let handler = Gmaps.build('Google'); // map init
  handler.buildMap({
    provider: {},
    internal: {
      id: 'map'
    }
  }, function () {
    if (company) {
      company = JSON.parse(company.replace(/&quot;/g, '"'));
    }
    if (company && company.latitude && company.longitude) { // statement check - new or edit view
      let markers = handler.addMarkers([ // print existent marker
        {
          'lat': company.latitude,
          'lng': company.longitude,
          'picture': {
            'url': '/images/map-marker.png',
            'width': 32,
            'height': 35
          }
        }
      ]);
      handler.bounds.extendWith(markers);
      handler.fitMapToBounds();
      handler.getMap().setZoom(6);
    } else { // show the empty map
      handler.fitMapToBounds();
      handler.map.centerOn([7.461940, 21.842188]);
      handler.getMap().setZoom(3);
    }
  });

  var markerOnMap;

  function placeMarker(location) { // simply method for put new marker on map
    if (markerOnMap) {
      markerOnMap.setPosition(location);
    } else {
      markerOnMap = new google.maps.Marker({
        position: location,
        map: handler.getMap()
      });
    }
  }

  google.maps.event.addListener(handler.getMap(), 'click', function (event) { // event for click-put marker on map and pass coordinates to hidden fields in form
    placeMarker(event.latLng);
    setLatLong(event.latLng);
  });

  const cityInput = document.getElementById('business_city_id');
  cityInput.onchange = getLocFromAddress;

  function getLocFromAddress() {
    let geocoder = new window.google.maps.Geocoder();
    let cityName = cityInput.options[cityInput.selectedIndex].text;
    geocoder.geocode({'address': cityName}, function (results, status) {
      if (status === 'OK') {
        let location = results[0].geometry.location;
        setLatLong(location);
        handler.map.centerOn(location);
        placeMarker(location);
      }
    });
  }

  function setLatLong(location) {
    document.getElementById('business_latitude').value = location.lat();
    document.getElementById('business_longitude').value = location.lng();
  }

}

export function gmap_show(company) {
  company = JSON.parse(company.replace(/&quot;/g, '"'));
  if ((company.latitude === null) || (company.longitude === null)) { // validation check if coordinates are there
    return 0;
  }

  let handler = Gmaps.build('Google'); // map init
  handler.buildMap({
    provider: {},
    internal: {
      id: 'map'
    }
  }, function () {
    let markers = handler.addMarkers([ // put marker method
      {
        'lat': company.latitude, // coordinates from parameter company
        'lng': company.longitude,
        'picture': {
          'url': '/images/map-marker.png',
          'width': 32,
          'height': 35
        },
        'infowindow': '<b>' + company.name + '</b> '
      }
    ]);
    handler.bounds.extendWith(markers);
    handler.fitMapToBounds();
    handler.getMap().setZoom(12); // set the default zoom of the map
  });
}


// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/google_map.js